import { ATTENTION_COLOR } from "constants/delivery-analytics";
import { Flag } from "lucide-react";
import type { FC } from "react";

export type LegendItemProps = {
  /** 帯・棒と対応させる色見本の色 */
  color: string;
  label: string;
  /** 「要対応」の ⚑ を添えるか */
  flag?: boolean;
};

/**
 * 図表に添える凡例 1 つ（内訳の横帯・グループ棒グラフで共用）。
 * 文字サイズ・文字色は置き場所のコンテナから継承する。
 * @param {LegendItemProps} props 色・ラベル・⚑ の有無
 * @return {JSX.Element} 凡例
 */
export const LegendItem: FC<LegendItemProps> = ({ color, label, flag }) => (
  <span className="inline-flex items-center gap-1.5">
    <i className="block h-2.5 w-2.5 rounded-sm" style={{ background: color }} />
    {label}
    {flag && <Flag size={12} aria-hidden style={{ color: ATTENTION_COLOR }} />}
  </span>
);
